import React, { useState } from "react";
import Popover from "@mui/material/Popover";
import { Button, Input, Text } from "sunrise-ui";
import { Grid } from "@material-ui/core";

const FilterComponent = (props: any) => {
  //popup show
  const [anchorEl, setAnchorEl] = useState<any>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      <Button
        category="border-only"
        size={props.size}
        onClick={handleClick}
        type="button"
        className="f14 mr-1 width-btn-img "
        isRounded={true}
        aria-describedby={id}
      >
        <span
          className="iconify filter-btn-spacing"
          data-icon="clarity:filter-2-line"
        ></span>
        <span className="filter-btn-text-spacing">Filter</span>
      </Button>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Grid container className="filter-popover-container">
          <Grid className="mb1 filter-input-width">
            <Text type="normal" fonts="normal" fontSize={16} className="mt0 mb">
              <span className="fw500">From</span>
            </Text>
            <Input
              color={"primary"}
              fonts="normal"
              placeholder="Write Here"
              required
              value={props.value.from}
              type="date"
              onChange={(e) =>
                props.setValue({ ...props.value, from: e.target.value })
              }
            />
          </Grid>
          <Grid className="filter-input-width">
            <Text type="normal" fonts="normal" fontSize={16} className="mb mt0">
              <span className="fw500">To</span>
            </Text>
            <Input
              color={"primary"}
              fonts="normal"
              placeholder="Write Here"
              required
              min={props.value.from}
              value={props.value.to}
              type="date"
              onChange={(e) =>
                props.setValue({ ...props.value, to: e.target.value })
              }
            />
          </Grid>
          <Grid container className="p1 m0" xs={12}>
            <Grid item className="mt0">
              <Button
                category="border-only"
                size="small"
                onClick={() => {
                  props.resetAll();
                  props.setValue({ from: "", to: "" });
                  handleClose();
                }}
                type="button"
                className="f14 mr-1 width-filter-btn"
                isRounded={true}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item xs={3} className="mt1">
              <Button
                category="primary"
                size="small"
                onClick={() => {
                  props.handleFilterDate();
                  handleClose();
                }}
                type="button"
                className="f14 width-filter-btn"
                isRounded={true}
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
};
export default FilterComponent;
